import { InjectionToken } from '@angular/core';
import { AssetsApiPort } from './assets-api.port';

export const ASSETS_API = new InjectionToken<AssetsApiPort>('ASSETS_API');
